import { FaBox, FaCarSide, FaTools } from 'react-icons/fa';
import { Button, Card, Col, Row, Space } from 'antd';

import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { useWorkorderItems } from '.';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

type Props = {
  onCancel: VoidFunction;
};

function SelectWorkOrderItemType({ onCancel }: Props) {
  const { itemType, setItemType, onNextStep, kit } = useWorkorderItems();

  const kitPermission =
    hasPermissions([
      Authorities.KITS_VIEW,
      Authorities.MOVIMENTATION_WORKORDER_KITS_ADD,
    ]) && !kit;

  return (
    <>
      <Row gutter={[16, 16]} justify="center" style={{ marginTop: '32px' }}>
        <Col span={24} md={kitPermission ? 8 : 12} key={'part'}>
          <Card
            className="invoice-create-steps-card"
            hoverable
            data-active={itemType === WorkOrderItemType.Part}
            onClick={() => setItemType(WorkOrderItemType.Part)}
          >
            <Space size="large" direction="horizontal" align="center">
              <FaCarSide size={48} />
              <span style={{ fontSize: '1.5em' }}>Peça</span>
            </Space>
          </Card>
        </Col>

        <Col span={24} md={kitPermission ? 8 : 12} key={'service'}>
          <Card
            className="invoice-create-steps-card"
            hoverable
            data-active={itemType === WorkOrderItemType.Service}
            onClick={() => setItemType(WorkOrderItemType.Service)}
          >
            <Space size="large" direction="horizontal" align="center">
              <FaTools size={48} />
              <span style={{ fontSize: '1.5em' }}>Serviço</span>
            </Space>
          </Card>
        </Col>

        {kitPermission && (
          <Col span={24} md={8} key={'kits'}>
            <Card
              className="invoice-create-steps-card"
              hoverable
              data-active={itemType === WorkOrderItemType.Kit}
              onClick={() => setItemType(WorkOrderItemType.Kit)}
            >
              <Space size="large" direction="horizontal" align="center">
                <FaBox size={48} />
                <span style={{ fontSize: '1.5em' }}>Kit</span>
              </Space>
            </Card>
          </Col>
        )}
      </Row>

      <SpaceForButton justifyContent="end" style={{ marginTop: '30px' }}>
        <Button block onClick={onCancel}>
          Cancelar
        </Button>

        <Button block type="primary" onClick={onNextStep} disabled={!itemType}>
          Próximo
        </Button>
      </SpaceForButton>
    </>
  );
}

export default SelectWorkOrderItemType;
